import { DraggableAttributes } from "@dnd-kit/core";
import { useSortable } from "@dnd-kit/sortable";
import { CSS } from "@dnd-kit/utilities";
import { SyntheticListenerMap } from "@dnd-kit/core/dist/hooks/utilities";

type SortableItemProps = {
  id: string;
  disabled?: boolean;
  children: (props: {
    dragHandleProps?: {
      attributes: DraggableAttributes;
      listeners: SyntheticListenerMap | undefined;
    };
    isDragging: boolean;
  }) => React.ReactNode;
};

export const SortableItem: React.FC<SortableItemProps> = ({
  id,
  disabled,
  children,
}) => {
  const {
    attributes,
    listeners,
    setNodeRef,
    transform,
    transition,
    isDragging,
  } = useSortable({ id, disabled });

  const style = {
    transform: CSS.Transform.toString(transform),
    transition,
    opacity: isDragging ? 0.5 : 1,
  };

  return (
    <div ref={setNodeRef} style={style}>
      {children({
        dragHandleProps: disabled
          ? undefined
          : {
              attributes,
              listeners,
            },
        isDragging,
      })}
    </div>
  );
};
